// 账号类型
export enum RoleTypeEnum {
  /**
   * 机构
   * */
  InstitutionsSettleIn = 2,
  /**
   * 选品
   * */
  SelectProductSettleIn = 1,
}

// 账号状态
export enum ReviewRoleStatusEnum {
  /**
   * 激活
   * */
  Activate = 1,
  /**
   * 禁用
   * */
  Disabled = 2,
}

export enum PushProductStatusEnum {
  /** 待发送 */
  waiting = 1,
  /** 发送中 */
  sending = 2,
  /** 发送完成 */
  sent = 3,
  /** 发送失败 */
  failed = 4,
  /** 取消 */
  cancel = 5,
}

export enum ProductStatusEnum {
  /** 上架 */
  OnShelf = 10,
  /** 隐藏 */
  Hidden = 5,
  /** 微信下架取消合作 */
  OffShelf = 15,
  /** 已删除 */
  Deleted = 3,
}

export enum MessageStatusEnum {
  /** 待发送 */
  waiting = 1,
  /** 发送中 */
  sending = 2,
  /** 发送完成 */
  sent = 3,
  /** 发送失败 */
  failed = 4,
  /** 取消 */
  cancel = 5,
}

export const MessageStatusMap = new Map([
  // 待发送
  [MessageStatusEnum.waiting, "待发送"],
  // 发送中
  [MessageStatusEnum.sending, "发送中"],
  // 发送完成
  [MessageStatusEnum.sent, "发送完成"],
  // 发送失败
  [MessageStatusEnum.failed, "发送失败"],
  // 取消
  [MessageStatusEnum.cancel, "取消"],
]);

export const ProductStatusMap = new Map([
  // 上架
  [ProductStatusEnum.OnShelf, "上架"],
  // 隐藏
  [ProductStatusEnum.Hidden, "隐藏"],
  // 微信那边下架，取消合作
  [ProductStatusEnum.OffShelf, "微信下架取消合作"],
  // 已删除
  [ProductStatusEnum.Deleted, "已删除"],
]);

// 账号状态 MAP
export const ReviewRoleStatusMap = new Map([
  // 激活
  [ReviewRoleStatusEnum.Activate, "激活"],
  // 禁用
  [ReviewRoleStatusEnum.Disabled, "禁用"],
]);

export const RoleTypeMap = new Map([
  // 机构
  [RoleTypeEnum.InstitutionsSettleIn, "机构"],
  // 选品
  [RoleTypeEnum.SelectProductSettleIn, "选品"],
]);

// SESSION_TOKE
export const OPR_SESSION_TOKEN = "loginToken";
// 登录路径
export const LOGIN_PATH = "/login";
